import {
  GET_PATIENT_DIET,
  CREATE_PATIENT_DIET,
  UPDATE_PATIENT_DIET,
  DELETE_PATIENT_DIET,
} from "../actions/types";

const initialState = {
  patientDietList: [], // Data store karne ke liye
  patientDietSaveStatus: null, // Create success/fail check karne ke liye
  patientDietUpdateStatus: null, // Update check karne ke liye
  patientDietDeleteStatus: null, // Delete check karne ke liye
};

export default function (state = initialState, action) {
  switch (action.type) {
    case GET_PATIENT_DIET:
      return {
        ...state,
        // Backend se aane wala data array
        patientDietList: action.payload.data || [], 
      };

    case CREATE_PATIENT_DIET:
      return {
        ...state,
        // Backend agar success: 1 bhej raha hai toh true set hoga
        patientDietSaveStatus: action.payload.success,
      };

    case UPDATE_PATIENT_DIET:
      return {
        ...state,
        patientDietUpdateStatus: action.payload.success,
      };

    case DELETE_PATIENT_DIET:
      return {
        ...state,
        patientDietDeleteStatus: action.payload.success,
      };

    default:
      return state;
  }
}